import { AiFillAndroid } from 'react-icons/ai';
import { MdDesignServices } from 'react-icons/md';
import { FaSwatchbook } from 'react-icons/fa';
import { GiBookCover } from 'react-icons/gi';
import { FaWineGlassAlt } from 'react-icons/fa';
import { RiVideoFill } from 'react-icons/ri';
import { GoDeviceMobile } from 'react-icons/go';
import { ImPencil } from 'react-icons/im';
const data = [
  {
    id: 1,
    Icon: AiFillAndroid,
    jobTitle: 'android development',
    experience: 'Having 4 years of Android deployed more than 7+ apps.',
  },
  {
    id: 2,
    Icon: FaSwatchbook,
    jobTitle: 'ui/ux design',
    experience: 'Having 4 years of Android deployed more than 7+ apps.',
  },
  {
    id: 3,
    Icon: MdDesignServices,
    jobTitle: 'logo design',
    experience: 'Having 4 years of Android deployed more than 7+ apps.',
  },
  {
    id: 4,
    Icon: GiBookCover,
    jobTitle: 'brochure design',
    experience: 'Having 4 years of Android deployed more than 7+ apps.',
  },
  {
    id: 5,
    Icon: FaWineGlassAlt,
    jobTitle: 'package design',
    experience: 'Having 4 years of Android deployed more than 7+ apps.',
  },
  {
    id: 6,
    Icon: RiVideoFill,
    jobTitle: 'motion design',
    experience: 'Having 4 years of Android deployed more than 7+ apps.',
  },
  {
    id: 7,
    Icon: GoDeviceMobile,
    jobTitle: 'digital marketing',
    experience: 'Having 4 years of Android deployed more than 7+ apps.',
  },
  {
    id: 8,
    Icon: ImPencil,
    jobTitle: 'copy writing',
    experience: 'Having 4 years of Android deployed more than 7+ apps.',
  },
];

export default data;
